import type { TFreqOctave } from '@web/entities/measurement'
import {
  EFreqOctaveOne,
  EFreqOctaveThird,
  EFreqOctaveTwo
} from '@web/entities/measurement/model/enums/octave.enum'
import type { IOption } from '@web/shared/types/options.type'

export const convertFreqOctave = (value: TFreqOctave): number => {
  if (value.startsWith('OCTAVE')) {
    const result = value.replace(/^OCTAVE_/, '').replace(/_/g, '.')

    return Number(result)
  }

  throw new Error(
    `[convertFreqOctave] Invalid octave value: "${value}". Expected format: OCTAVE_x or OCTAVE_x_y`
  )
}

export const toFrequencyOctaveOptions = <T extends TFreqOctave>(
  enumObj: Record<string, T>
): Array<IOption<T>> =>
  Object.values(enumObj)
    .map((value) => {
      const number = convertFreqOctave(value)

      return {
        value,
        label: number.toString(),
        number
      }
    })
    .sort((a, b) => b.number - a.number)

export const toFreqOctave = (value: number): TFreqOctave => {
  if (Number.isNaN(value)) {
    throw new Error(`[toFreqOctave] NaN is not allowed`)
  }

  const ALL_OCTAVES = new Set<string>([
    ...Object.values(EFreqOctaveOne),
    ...Object.values(EFreqOctaveTwo),
    ...Object.values(EFreqOctaveThird)
  ])

  const normalized = value.toString().replace('.', '_')

  const key = `OCTAVE_${normalized}`

  if (ALL_OCTAVES.has(key)) {
    return key as TFreqOctave
  }

  throw new Error(
    `[toFreqOctave] Invalid octave number: "${value}". No matching enum value`
  )
}
